var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeecontri({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 48,
    viewBox: "0 0 258 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6282_5299)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 257,
    height: 48,
    fill: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 42,
    width: 6,
    height: 6,
    transform: "rotate(-90 0.5 42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 48,
    width: 6,
    height: 6,
    transform: "rotate(-90 6.5 48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0.5 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 48,
    width: 6,
    height: 6,
    transform: "rotate(-90 239.5 48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.5,
    y: 42,
    width: 6,
    height: 6,
    transform: "rotate(-90 245.5 42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 251.5 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.5,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 245.5 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 48,
    width: 6,
    height: 6,
    transform: "rotate(-90 251.5 48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 31.18C52.7 31.18 51.08 29.44 51 26.8H52.78C52.88 28.5 53.9 29.56 56.1 29.56C58.14 29.56 59.32 28.76 59.32 27.16C59.32 25.8 58.54 25.2 57.02 24.88L54.98 24.44C52.76 23.96 51.48 22.8 51.48 20.66C51.48 18.4 53.22 16.82 56.12 16.82C58.92 16.82 60.88 18.5 60.9 20.98H59.12C59.04 19.46 58.04 18.46 56.08 18.46C54.42 18.46 53.28 19.18 53.28 20.66C53.28 21.8 53.98 22.4 55.46 22.74L57.36 23.18C59.76 23.74 61.14 24.86 61.14 27.16C61.14 29.66 59.14 31.18 56.1 31.18ZM66.2661 31.18C63.7061 31.18 62.0461 29.62 62.0461 26.9V24.88C62.0461 22.16 63.7061 20.6 66.2661 20.6C68.6661 20.6 70.4061 21.96 70.4461 24.88V26.5H63.7461V26.9C63.7461 28.98 64.7861 29.58 66.2661 29.58C67.5061 29.58 68.5461 29.14 68.7261 27.78H70.4261C70.2461 29.94 68.5261 31.18 66.2661 31.18ZM63.7461 25H68.7461V24.88C68.7061 22.84 67.6061 22.16 66.2661 22.16C64.7861 22.16 63.7461 22.84 63.7461 24.88V25ZM75.4567 31.18C72.8967 31.18 71.2367 29.62 71.2367 26.9V24.88C71.2367 22.16 72.8967 20.6 75.4567 20.6C77.8567 20.6 79.5967 21.96 79.6367 24.88V26.5H72.9367V26.9C72.9367 28.98 73.9767 29.58 75.4567 29.58C76.6967 29.58 77.7367 29.14 77.9167 27.78H79.6167C79.4367 29.94 77.7167 31.18 75.4567 31.18ZM72.9367 25H77.9367V24.88C77.8967 22.84 76.7967 22.16 75.4567 22.16C73.9767 22.16 72.9367 22.84 72.9367 24.88V25ZM88.4469 31.18C85.8869 31.18 84.2469 29.62 84.2469 26.9V24.88C84.2469 22.16 85.8869 20.6 88.4469 20.6C89.4669 20.6 90.3269 20.9 90.9669 21.46V20.78H92.6669V31H90.9669V30.32C90.3269 30.88 89.4669 31.18 88.4469 31.18ZM85.9469 26.9C85.9469 28.98 86.9669 29.58 88.4469 29.58C89.8269 29.58 90.9669 28.98 90.9669 26.9V24.88C90.9669 23 89.8269 22.2 88.4469 22.2C86.9669 22.2 85.9469 23 85.9469 24.88V26.9ZM97.1825 31C95.6025 31 94.8625 30.18 94.8625 28.92V16.2H96.5625V29.4H98.3025V31H97.1825ZM101.627 31C100.047 31 99.307 30.18 99.307 28.92V16.2H101.007V29.4H102.747V31H101.627ZM112.491 31.18C108.971 31.18 106.971 29.02 106.971 25.2V22.8C106.971 18.98 108.971 16.82 112.491 16.82C115.831 16.82 117.691 18.8 117.931 21.86H116.111C115.891 19.92 114.951 18.52 112.491 18.52C109.791 18.52 108.771 20.18 108.771 22.8V25.2C108.771 27.82 109.791 29.48 112.491 29.48C114.891 29.48 115.891 28.16 116.071 26.3H117.891C117.631 29.28 115.791 31.18 112.491 31.18ZM118.93 24.88C118.93 22.16 120.59 20.6 123.15 20.6C125.71 20.6 127.35 22.16 127.35 24.88V26.9C127.35 29.62 125.71 31.18 123.15 31.18C120.59 31.18 118.93 29.62 118.93 26.9V24.88ZM120.63 26.9C120.63 28.98 121.67 29.58 123.15 29.58C124.63 29.58 125.65 28.98 125.65 26.9V24.88C125.65 23 124.63 22.2 123.15 22.2C121.67 22.2 120.63 23 120.63 24.88V26.9ZM128.96 31V20.78H130.66V21.82C131.2 21.06 132.18 20.6 133.54 20.6C135.8 20.6 137.3 22.12 137.3 24.46V31H135.6V24.84C135.6 23.12 134.78 22.2 133.16 22.2C131.8 22.2 130.66 22.94 130.66 24.84V31H128.96ZM142.718 31C140.698 31 139.998 29.86 139.998 28.46V22.38H138.498V20.78H140.038V18.5H141.698V20.78H144.198V22.38H141.698V29.4H144.238V31H142.718ZM145.74 31V20.78H147.44V21.96C147.94 21.22 148.68 20.78 150.04 20.78H151.06V22.48H150.04C148.5 22.48 147.44 23.34 147.44 25.46V31H145.74ZM152.252 31V20.78H153.932V31H152.252ZM152.152 18.66V16.7H154.032V18.66H152.152ZM160.45 31.18C159.43 31.18 158.57 30.88 157.93 30.32V31H156.23V16.2H157.93V21.46C158.57 20.9 159.43 20.6 160.45 20.6C163.01 20.6 164.65 22.16 164.65 24.88V26.9C164.65 29.62 163.01 31.18 160.45 31.18ZM157.93 26.9C157.93 28.98 159.07 29.58 160.45 29.58C161.93 29.58 162.95 28.98 162.95 26.9V24.88C162.95 23 161.93 22.2 160.45 22.2C159.07 22.2 157.93 23 157.93 24.88V26.9ZM172.561 26.94V20.78H174.261V27.32C174.261 29.66 172.821 31.18 170.161 31.18C167.481 31.18 166.041 29.66 166.041 27.32V20.78H167.741V26.94C167.741 28.66 168.501 29.58 170.161 29.58C171.801 29.58 172.561 28.66 172.561 26.94ZM179.687 31C177.667 31 176.967 29.86 176.967 28.46V22.38H175.467V20.78H177.007V18.5H178.667V20.78H181.167V22.38H178.667V29.4H181.207V31H179.687ZM181.909 24.88C181.909 22.16 183.569 20.6 186.129 20.6C188.689 20.6 190.329 22.16 190.329 24.88V26.9C190.329 29.62 188.689 31.18 186.129 31.18C183.569 31.18 181.909 29.62 181.909 26.9V24.88ZM183.609 26.9C183.609 28.98 184.649 29.58 186.129 29.58C187.609 29.58 188.629 28.98 188.629 26.9V24.88C188.629 23 187.609 22.2 186.129 22.2C184.649 22.2 183.609 23 183.609 24.88V26.9ZM191.938 31V20.78H193.638V21.96C194.138 21.22 194.878 20.78 196.238 20.78H197.258V22.48H196.238C194.698 22.48 193.638 23.34 193.638 25.46V31H191.938ZM201.931 31.18C199.511 31.18 197.811 30 197.751 27.62H199.431C199.431 28.98 200.471 29.58 201.931 29.58C203.411 29.58 204.271 28.96 204.271 28.1C204.271 27.48 203.831 27.04 202.911 26.8L200.511 26.2C199.051 25.84 198.171 24.94 198.171 23.48C198.171 21.86 199.491 20.6 201.831 20.6C204.151 20.6 205.731 21.96 205.731 23.9H204.091C204.031 22.7 203.111 22.14 201.831 22.14C200.471 22.14 199.791 22.74 199.791 23.48C199.791 24.24 200.371 24.5 201.091 24.68L203.271 25.22C205.011 25.66 205.971 26.54 205.971 28.1C205.971 29.86 204.471 31.18 201.931 31.18Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 256.5,
    height: 47.5,
    stroke: "#FE5B4A",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6282_5299"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 257,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeecontri);
export default __webpack_public_path__ + "static/media/seecontri.de5895fb833cb178eb15530d19f6122a.svg";
export { ForwardRef as ReactComponent };